import { SVGProps } from "react";

const Pencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.274}
    height={17.989}
    {...props}
  >
    <g fill="#404040" data-name="Group 12698">
      <path
        d="M3.172 14.634a1.09 1.09 0 0 1-1.243-1.206c.072-.84.136-1.682.245-2.518a2.6 2.6 0 0 1 .317-.737.78.78 0 0 1 .174-.19L11.911.735a2.383 2.383 0 0 1 3.439 0c.208.206.419.409.616.625a2.3 2.3 0 0 1 .007 3.118c-.3.329-.622.637-.937.952q-4.128 4.131-8.253 8.266a2.251 2.251 0 0 1-1.579.759c-.709.027-1.415.125-2.032.183m8.02-11.421a1.707 1.707 0 0 1-.139.181Q7.4 7.058 3.742 10.71a.992.992 0 0 0-.357.776 5.109 5.109 0 0 1-.056.614c-.035.4-.069.8-.1 1.22h.177c.654-.059 1.31-.111 1.963-.185a.627.627 0 0 0 .334-.183q3.745-3.735 7.484-7.477a1.234 1.234 0 0 1 .151-.112l-2.146-2.15M14.258 4.4c.25-.251.5-.5.743-.75a1.027 1.027 0 0 0 .022-1.439c-.218-.241-.45-.47-.689-.691a.987.987 0 0 0-1.3-.065 10.061 10.061 0 0 0-.835.886L14.258 4.4"
        data-name="Path 24121"
      />
      <path
        d="M9.147 17.99H.777a1.123 1.123 0 0 1-.459-.091.591.591 0 0 1-.309-.654.629.629 0 0 1 .482-.5 1.32 1.32 0 0 1 .276-.024h16.74c.484 0 .779.257.766.666a.628.628 0 0 1-.577.605c-.08.006-.159 0-.239 0h-8.31"
        data-name="Path 24122"
      />
    </g>
  </svg>
);
export default Pencil;
